module.exports = __webpack_public_path__ + "static/media/FAQpattern.11a9e462.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FAQ/FAQpattern.png
// module id = 486
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 31